export const seriesPoints = [
  {
    id: "repeat",
    icon: "ri-repeat-2-line",
    title: "同一题材的反复翻拍",
    desc:
      "同一段故事在不同年代被不同团队重新拍摄，片名往往相近，适合放在一起横向对照，观察叙事重心如何随时间移动。",
  },
  {
    id: "studio",
    icon: "ri-building-2-line",
    title: "片厂与工作室出品系列",
    desc:
      "某些时期由同一制片机构连续推出相关影片，布景、班底与影像风格彼此接近，呈现出系列化的整体面貌。",
  },
  {
    id: "casting",
    icon: "ri-user-star-line",
    title: "不同演员的版本对照",
    desc:
      "同一人物由不同演员诠释，气质与表演方式差异明显，是这一题材最常被观众讨论与比较的角度之一。",
  },
  {
    id: "region",
    icon: "ri-global-line",
    title: "跨地区的重制与改编",
    desc:
      "不同地区在改编时会加入本地审美与叙事习惯，同一故事因此衍生出多个互不相同的版本，构成更宽的系列范围。",
  },
];